import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import stepSound from './audio/422990__dkiller2204__sfxrunground1.wav';
import wallSound from './audio/138476__justinvoke__step-tap.wav';
import wrongSound from './audio/483598__raclure__wrong.mp3';
import rightSound from './audio/405547__raclure__affirmative-decision-chime.wav';

const fxAudio = new Audio(stepSound);

export function playStepSound(){
  fxAudio.src = stepSound;
  fxAudio.play();
}

export function playWallSound(){
  fxAudio.src = wallSound;
  fxAudio.play();
}

export function playWrongSound(){
  fxAudio.src = wrongSound;
  fxAudio.play();
}

export function playRightSound(){
  fxAudio.src = rightSound;
  fxAudio.play();
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
